











import Vue from "vue";
import Component from "vue-class-component";
import { RouteConfig } from "vue-router";
import { EditUserRoute } from "../../router";

@Component
export default class UserManagementEditButton extends Vue {
    get editRoute(): RouteConfig {
        return EditUserRoute;
    }
}
